import styled from "styled-components";
import { media } from "../../../../../components/common/media";

const CategoriesContainer = styled.section`
  padding: 0 20px 40px;
  margin-bottom: 20px;
  ${media.desktop`
    padding: 0 0 40px;
  `}
  .video-categories {
    .flex {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: stretch;
      width: 100%;
      max-width: 1230px;
      margin: 20px auto auto;
      ${media.desktop`
        display: block;
      `};
      .item-container {
        position: relative;
        margin: 5px;
        .overlay {
          transition: all 0.6s ease 0s;
          background: rgba(0, 0, 0, 0.36);
          border-radius: 10px;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
        }
        &:hover {
          .overlay {
            background: rgba(0, 0, 0, 0.6);
          }
        }
        h4 {
          position: absolute;
          left: 0;
          right: 0;
          top: 30px;
          bottom: 0;
          margin: auto;
          text-align: center;
          color: #fff;
          font-weight: 700;
          ${media.phone`
            top: auto;
            bottom: 30px;
          `};
        }
      }
      .left {
        display: flex;
        flex-wrap: wrap;
        width: 48%;
        justify-content: space-around;
        ${media.desktop`
          width: 100%;
          margin-bottom: 30px;
          a {
            flex: 50%;
            ${media.phone`
              flex: 1 1 auto;
              width: 50%;
              img {
                height: 150px;
              }
              h4 { 
                font-size: 21px;
                letter-spacing: 0.25px;
                top: 45%;
                &.awesome,
                &.humor {
                  top: 45%;
                }
              }
            `}
          }
        `};
        .overlay {
          border-radius: 0;
        }
        img {
          width: 275px;
          height: 275px;
          ${media.desktop`
            width: 100%;
          `};
        }
        h4 {
          font-size: 35px;
          &.awesome,
          &.humor {
            bottom: 30px;
            top: auto;
          }
        }
      }
      .right {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        width: 48%;
        margin-top: 15px;

        img {
          width: 185px;
          height: 77px;
          border-radius: 10px;
        }
        h4 {
          top: 0;
          font-size: 21px;
          line-height: 80px;
        }
        ${media.desktop`
          width: 100%;
          justify-content: flex-start;
          
        `};
        ${media.phone`
          justify-content: space-evenly;
          img {
            width: 150px;
            height: 50px;
            border-radius: 4px;
          }
          h4 {
            top: 0;
            font-size: 21px;
            line-height: 50px;
          }
        `}
      }
    }
    .slide {
      background: transparent;
    }
  }

  @media screen and (min-width: 767px) {
  }
`;

export default CategoriesContainer;
